import React from 'react';
import './App.css';
import { firebase } from '@firebase/app';
import 'react-quill/dist/quill.snow.css';
import  EditorComponent from "./editor/editor"
import SidebarComponent from "./sidebar/sidebar"

class App extends React.Component {

  constructor(){
    super()
    this.state = {
      selectedNoteIndex: null,
      selectedNote: null,
      notes: null
    }
  }

  render() {
    return (
      <div className="flex-container">
          <div className="header">
             <h2>EVERNOTE</h2>            
            <img
                className="header__logo"
                // src="https://logos-world.net/wp-content/uploads/2020/09/Tinder-Emblem.png"
                src = "https://img.icons8.com/clouds/100/000000/notes-app.png"
                alt=""
            />
            {/* <Button>
            <ForumIcon fontSize='large' className="header__icon" ></ForumIcon>
            </Button> */}
            
          </div>
          <div className="app-container">
      
            <SidebarComponent 
              selectedNoteIndex={this.state.selectedNoteIndex}
              notes={this.state.notes}
              deleteNote={this.deleteNote}
              selectNote={this.selectNote}
              newNote={this.newNote}>
            </SidebarComponent>
            {
              this.state.selectedNote ? 
              <EditorComponent selectedNote={this.state.selectedNote}
              selectedNoteIndex={this.state.selectedNoteIndex}
              notes={this.state.notes}
              noteUpdate={this.noteUpdate}></EditorComponent> : 
              null
            }
      
          </div>
      </div>
   
    )
  }

  componentDidMount = () => {
    firebase
      .firestore()
      .collection('notes')
      .onSnapshot(serverUpdate => {
        const notes = serverUpdate.docs.map(_doc => {
          const data = _doc.data();
          data['id'] = _doc.id;
          return data;
        });
          console.log(notes)
          this.setState({ notes: notes})
      });
  }

  selectNote= (note, index) => this.setState({ selectedNoteIndex: index, selectedNote: note})
  noteUpdate = (id , noteObj) => {
    firebase
      .firestore()
      .collection('notes')
      .doc(id)
      .update({
        title: noteObj.title,
        body: noteObj.body,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      })
  }

  newNote= async (title) => { 
    const note = {
      title: title,
      body: ''
    }
    if(note.title === null){
      alert("Please enter a Title!");
    }else {
      
      const newFromDB = await firebase
        .firestore()
        .collection('notes')
        .add({
          title: note.title,
          body: note.body,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })
      const newID = newFromDB.id;
      await this.setState({notes : [...this.state.notes, note]})
      const newNoteIndex = this.state.notes.indexOf(this.state.notes.filter(_note => _note.id === newID)[0])
      this.setState({ selectedNote: this.state.notes[newNoteIndex], selectedNoteIndex: newNoteIndex}) 
    }
    
  }
  
  
  deleteNote  = async (note) => {
    const noteIndex = this.state.notes.indexOf(note)
    await this.setState({ notes: this.state.notes.filter(_note => _note !== note)})
    if(this.state.selectedNoteIndex === noteIndex){
      this.setState({ selectedNoteIndex: null, selectedNote: null })
    }
    else{
      this.state.notes.length > 1 ? 
      this.selectNote(this.state.notes[this.state.selectedNoteIndex - 1], this.state.selectedNoteIndex - 1) :
      this.setState({ selectedNoteIndex: null, selectedNote: null })
    }

    firebase
      .firestore()
      .collection('notes')
      .doc(note.id)
      .delete() 
  }
}

export default App;
